// extracted by mini-css-extract-plugin
export default {"wrapper":"status___wrapper___b2b3ee81","tag":"status___tag___e614b3aa"};